// Paginado de 25 en 25 para listas que ya vienen completas del backend (catálogos, gestión).
// Uso (ver ESTANDAR_LISTADOS.md):
//   <tr v-for="item in paginar(lista)">  …
//   <PaginacionListado :pagina="paginaActualDe(lista)" :total-paginas="totalPaginasDe(lista)"
//     :total="lista.length" :por-pagina="porPagina" :en-pagina="paginar(lista).length" @cambiar="pagina = $event" />
// Al filtrar o limpiar filtros: this.pagina = 1
export default {
  data() {
    return {
      pagina: 1,
      porPagina: 25,
    }
  },
  methods: {
    totalPaginasDe(lista) {
      return Math.max(1, Math.ceil((lista || []).length / this.porPagina))
    },
    // Si la lista se achicó (filtro, eliminación), no quedarse en una página que ya no existe
    paginaActualDe(lista) {
      return Math.min(this.pagina, this.totalPaginasDe(lista))
    },
    paginar(lista) {
      const inicio = (this.paginaActualDe(lista) - 1) * this.porPagina
      return (lista || []).slice(inicio, inicio + this.porPagina)
    },
  },
}
